/**
 * jw-image-resolver.js
 * Phase F1.2 — Shared variant image resolver (single source of truth)
 *
 * 职责：给定 sku + imageBinding + skuImages → 返回正确的 SKU 图片 URL
 *
 * 策略：
 *   option1_binding → 从 image_binding.bindings[option1] 查文件名，再从 skuImages 取 URL
 *   null / 不可用    → 回退到 sku.image / sku.img / sku.thumb
 *
 * 兼容两种 sku.options 格式：
 *   1. J产品详情页（product.liquid inline / jw-product-sku-core）:
 *      options: ["Pink", "S"] （纯字符串数组）
 *   2. Quick Add 抽屉（jw-components.js）:
 *      options: [{name: "Color", value: "Pink"}, ...] （对象数组）
 *
 * 使用方式：
 *   // 在 product.liquid inline 引入后：
 *   var img = window.JWImageResolver.resolve(sku, binding, images);
 *
 *   // 在 jw-components.js 引入后：
 *   var img = window.JWImageResolver.resolve(sku, state.imageBinding, state.skuImages);
 */

(function() {
  'use strict';

  /**
   * 提取 SKU 的 option1 值（兼容字符串和对象格式）
   * @param {object} sku — { options: [...] }
   * @returns {string}
   */
  function getOption1(sku) {
    if (!sku || !sku.options || !sku.options.length) return '';
    var first = sku.options[0];
    if (typeof first === 'string') return first;
    if (first && typeof first === 'object') return first.value || '';
    return '';
  }

  /**
   * 解析 SKU 图片 URL
   *
   * @param {object} sku          — SKU 对象 { options, image?, img?, thumb? }
   * @param {object|null} binding — imageBinding { strategy, bindings: {rawOption1: filename} }
   * @param {object} skuImages    — { key: url } 的图片字典
   * @returns {string} 图片 URL，找不到返回空字符串
   */
  function resolveVariantImage(sku, binding, skuImages) {
    if (!sku) return '';

    // strategy: option1_binding
    if (binding && binding.strategy === 'option1_binding' && binding.bindings) {
      var rawOpt1 = getOption1(sku);
      if (rawOpt1) {
        var boundFile = binding.bindings[rawOpt1];
        if (boundFile) {
          var imgs = skuImages || {};
          for (var key in imgs) {
            if (key === boundFile || key.endsWith('/' + boundFile)) {
              return imgs[key];
            }
          }
        }
      }
    }

    // Fallback: variant 自身图片
    return sku.image || sku.img || sku.thumb || '';
  }

  // ── 挂载到 window ──
  window.JWImageResolver = {
    resolve: resolveVariantImage,
    getOption1: getOption1
  };

})();
